import axios from "@axios";
import moment from "moment-timezone";
import store from "@/store";
import { getUserData } from "@/auth/utils";
import ability from "@/libs/acl/ability";
import {useUtils as useI18nUtils} from "@core/libs/i18n";

export default {
  namespaced: true,
  state: {
    items: [],
    helpdeskNotifications: [],
  },
  getters: {
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
    setDataNotification(state, value) {
      state.helpdeskNotifications = value
    },
  },
  actions: {
    //Catalogo Siniestro Tipos/Subtipos
    async getAllFailureCategories({ commit }, params) {
        const { data } = await axios.get('v1/helpdesk/failure-categories', {
            params: {
            catalog: ['siniestro'],
            ...params,
            }
        })

        if (!data.success) {
            return []
        }

        commit('setData', data.data)
        return data
    },

    async getFailureCategories(_, {id, params}) {
        const {data} = await axios.post(`v1/helpdesk/failure-categories/${id}`, params, {
        })

        return data
    },

    async addFailureCategories(_, params) {
        const { data } = await axios.post('v1/helpdesk/failure-categories', params, {
            headers: { "Content-Type": "application/json" },
        })
        
        return data
    },

    async editFailureCategories(_, {id, params}) {
      const {data} = await axios.put(`v1/helpdesk/failure-categories/${id}`, params)

      return data
    },

    async deleteFailureCategories(_, id) {
      const {data} = await axios.delete(`v1/helpdesk/failure-categories/${id}`)

      return data
    },

    //Catalogo Tramos carreteros
    async getAllRoadSection({ commit }, params) {
        const { data } = await axios.get('v1/helpdesk/road-sections', {
            params: {
            ...params,
            }
        })

        if (!data.success) {
            return []
        }

        commit('setData', data.data)
        return data
    },

    async getRoadSection(_, {id, params}) {
        const {data} = await axios.post(`v1/helpdesk/road-sections/${id}`, params, {
        })

        return data
    },

    async addRoadSection(_, params) {
        const { data } = await axios.post('v1/helpdesk/road-sections', params, {
            headers: { "Content-Type": "application/json" },
        })
        
        return data
    },

    async editRoadSection(_, {id, params}) {
      const {data} = await axios.put(`v1/helpdesk/road-sections/${id}`, params)

      return data
    },

    async deleteRoadSection(_, id) {
      const {data} = await axios.delete(`v1/helpdesk/road-sections/${id}`)

      return data
    },

    //Tickets
    async getAllTickets({ commit }, params) {
      const { data } = await axios.get('v1/helpdesk/ticket', {
          params: {
          ...params,
          }
      })

      if (!data.success) {
          return []
      }

      commit('setData', data.data)
      return data
  },

  async getTicket(_, {id, params}) {
      const {data} = await axios.get(`v1/helpdesk/ticket/${id}`, params, {
      })

      return data
  },

  // params es FormData (adjuntos): axios define el multipart/form-data
  async addTicket(_, params) {
      const { data } = await axios.post('v1/helpdesk/ticket', params)

      return data
  },

  async getTicketFailureCategories(_, catalog) {
      const { data } = await axios.get('v1/helpdesk/failure-categories', {
          params: { catalog: [catalog] }
      })

      return data.success ? data.data : []
  },

  async getMyOpenTickets({ commit }) {
      const params = { open: true, sortBy: 'updated_at', sortDesc: true, max: 50 }
      if (!ability.can('assign', 'HelpdeskTicket')) {
          params.involved_user = getUserData().id
      }
      const { data } = await axios.get('v1/helpdesk/ticket', { params })

      commit('setDataNotification', data.success ? data.data : [])
      return data
  },

  async getProviders() {
      const { data } = await axios.get('v1/helpdesk/providers')

      return data.success ? data.data : []
  },

  async getPriorities() {
      const { data } = await axios.get('v1/helpdesk/priorities', {
          params: { sortBy: 'level', sortDesc: false }
      })

      return data.success ? data.data : []
  },

  async editTicket(_, {id, params}) {
    const {data} = await axios.put(`v1/helpdesk/ticket/${id}`, params)

    return data
  },

  async addTicketComment(_, {id, params}) {
    const {data} = await axios.post(`v1/helpdesk/ticket/${id}/comment`, params)

    return data
  },

  async saveFailureAnalysis(_, {id, params}) {
    const {data} = await axios.post(`v1/helpdesk/ticket/${id}/analysis`, params)

    return data
  },

  // action: assign | reassign | plan | pending | solve | validate | reject-validation | close | reopen
  async changeTicketStatus(_, {id, action, params}) {
    const {data} = await axios.post(`v1/helpdesk/ticket/${id}/${action}`, params)

    return data
  },


    clear({commit}) {
      commit('setData', [])
    }
  },
}
